import { unstable_batchedUpdates } from 'react-dom'
import { usePersistFn } from 'ahooks'

const useSetDataTogether = () =>
    usePersistFn((cb: () => void) =>
        Promise.resolve().then(() => {
            unstable_batchedUpdates(cb)
        }),
    )

export default useSetDataTogether
